import {createFeatureSelector, createSelector} from "@ngrx/store";
import {NOTIFICATIONS_STATE_NAME, NotificationsState} from "./notificationCenter";

export const selectNotificationsState = createFeatureSelector<NotificationsState>(NOTIFICATIONS_STATE_NAME);

export const selectNotifications = createSelector(
  selectNotificationsState,
  (notificationCenterState: NotificationsState) => notificationCenterState.notifications
);

export const selectNotificationsLoading = createSelector(
  selectNotificationsState,
  (notificationCenterState: NotificationsState) => notificationCenterState.loading
);

export const selectNotificationsLoaded = createSelector(
  selectNotificationsState,
  (notificationCenterState: NotificationsState) => notificationCenterState.loaded
);
